import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'ChevronLeft',
  props: {
    fill: {
      type: String,
      default: 'black',
    },
    size: {
      type: [String, Number],
      default: '24',
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: "0 0 24 24"
  }, [
    _createElementVNode("path", {
      d: "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z",
      fill: __props.fill
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})